<template>
  <div
    v-b-popover.hover.right.html="getSpanHover(data.item.final_statement , 'add')"
    class="hover-pointer"
    @click="finalStatement(data.item.id)"
  >
    <span style="font-size: smaller;">
      {{ getSmallName(data.item.final_statement) }}
    </span>
  </div>
</template>

<script>
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import decryptData from '@/store/auth/decryptData'

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    getAllData: {
      type: Function,
      required: true,
    },
  },

  methods: {
    finalStatement(id) {
      this.$swal({
        title: 'Set final statement to this Internal Audit?',
        input: 'textarea', // 👈 input field for remark
        inputPlaceholder: 'Enter your statement (optional)',
        inputAttributes: {
          'aria-label': 'Enter your statement',
        },
        width: 600,
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Approve',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        preConfirm: remark => {
          if (!remark) {
            return '' // allow empty remarks if not entered
          }
          return remark
        },
      }).then(result => {
        if (result.isConfirmed) {
          axios.patch(`internal-audit/${id}/final-statement`, {
            final_statement: result.value || '',
          })
            .then(() => {
              this.$toast.success('Add Final Statement Successfully!')
              this.getAllData()
            })
            .catch(error => {
              const payload = decryptData(error.response.data.payload).message
              const firstArrayKey = Object.keys(payload).find(key => Array.isArray(payload[key]))
              const errorMessage = firstArrayKey ? payload[firstArrayKey][0] : 'An unknown error occurred'
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errorMessage,
                  icon: 'BellIcon',
                  variant: 'error',
                },
              })
            })
        }
      })
    },

    getSmallName(input) {
      if (!input) return ''

      const dateMatch = input.match(/\d{4}-\d{2}-\d{2}/)
      if (dateMatch) {
        return dateMatch[0]
      }

      const words = input.trim().split(/\s+/)
      if (words.length <= 8) {
        return input
      }
      return `${words.slice(0, 8).join(' ')}...`
    },
    getSpanHover(name, action) {
      if (name) {
        return `<div style=" text-align: center; color: black">🔄 change</div>
          <div>${name}</div>`
      }
      return `<div style=" text-align: center; color: black">➕ ${action || ''}</div>`
    },
  },
}
</script>
